import Repository from "./Repository";

const ADD_VOLUNTEER = "addvolunteer";
const EMAIL_BECOME_VOL = "emailbecomevol";

export default {
  addVolunteerHCP(payload) {
    return Repository.post(transformRoute(ADD_VOLUNTEER), payload);
  },

  emailBecomeVolunteer(payload) {
    return Repository.post(transformRouteemail(EMAIL_BECOME_VOL), payload);
  },
};

const transformRoute = (route) => {
  return `/hcp/volunteer/${route}`;
};
const transformRouteemail = (route) => {
  return `/hcp/email/${route}`;
};
